import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikProps, withFormik } from 'formik';
import styled from 'styled-components';

import { PasswordField } from '@/components/shared/PasswordField';
import { PasswordPolicy } from '@/components/shared/PasswordPolicy';
import * as constants from '@/constants';
import { evaluatePasswordStrength } from '@/utils/evaluatePasswordStrength';
import { Label } from '@/components/shared/Label';
import { SharedButton } from '@/components/shared/Button';

const strengthMeter = evaluatePasswordStrength(constants.PASSWORD_PATTERN);

type OuterProps = {
  isDisable: boolean;
  onSubmit: (password: string) => void;
};

type Values = {
  password: string;
};

export const PasswordResetForm = withFormik<OuterProps, Values>({
  mapPropsToValues: () => ({
    password: '',
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values.password);
    setSubmitting(false);
  },
})(
  // enhanced form
  ({
    errors,
    handleChange,
    handleSubmit,
    isDisable = false,
    touched,
    values,
  }: OuterProps & FormikProps<Values>) => {
    const { t } = useTranslation();
    return (
      <form onSubmit={handleSubmit}>
        <PasswordField
          id={'password'}
          label={t('ui.password.label')}
          placeholder={t('ui.password.placeholder')}
          onChange={handleChange}
          strengthMeter={strengthMeter}
          value={values.password}
        />
        {touched.password && errors.password && (
          <div>
            <Label>{errors.password}</Label>
          </div>
        )}
        <PasswordPolicy />

        <SubmitButton>
          <SharedButton
            dataTest="do-activation"
            disabled={strengthMeter(values.password) < 2 || isDisable}
            type="submit"
          >
            {t('ui.action.resetPassword')}
          </SharedButton>
        </SubmitButton>
      </form>
    );
  },
);

const SubmitButton = styled.div`
  color: #bbb;
  text-align: center;
`;
